const initialState = {
    alerts: [],
    // contentData: {
    //     url: '',
    //     key: '',
    //     blocks: []
    // },
    userData: {
        blocks: [],
        geoLocation: {}
    },
    history: [],
    searchResult: [],
    dialog: {},
    searchDialog: {},
    currentAction: '',
    // sessionKey: '',
    appStatus: 'calm'
};

// export function contentData(state = initialState.contentData, action) {
//     switch (action.type) {
//         case 'SET_CONTENT_DATA':
//             return action.contentData || initialState.contentData;
//         default:
//             return state;
//     }
// }

// export function sessionKey(state = initialState.sessionKey, action) {
//     switch (action.type) {
//         case 'SET_SESSION_KEY':
//             return action.sessionKey || initialState.sessionKey;
//         default:
//             return state;
//     }
// }

export function history(state = initialState.history, action) {
    switch (action.type) {
        case 'ADD_HISTORY_PAGE':
            return state.concat(action.history) || initialState.history;

        case 'UPDATE':
            state[state.length-1] = action.history;
            return state;

        case 'GO_BACK':
            return state.slice(0, -1) || initialState.history;

        case 'CLEAR':
            return initialState.history;

        default:
            return state;
    }
}

export function dialog(state = initialState.dialog, action) {
    switch (action.type) {
        case 'SET_DIALOG':
            return action.dialog || initialState.dialog;
        default:
            return state;
    }
}

export function searchResult(state = initialState.searchResult, action) {
    switch (action.type) {
        case 'SET_SEARCH_RESULT':
            return action.searchResult || initialState.searchResult;
        default:
            return state;
    }
}

export function searchDialog(state = initialState.searchDialog, action) {
    switch (action.type) {
        case 'SET_SEARCH_DIALOG':
            return action.searchDialog || initialState.searchDialog;
        default:
            return state;
    }
}

export function userData(state = initialState.userData, action) {
    switch (action.type) {
        case 'SET_USER_DATA':
            return action.userData || initialState.userData;
        default:
            return state;
    }
}

export function currentAction(state = initialState.currentAction, action) {
    switch (action.type) {
        case 'SET_CURRENT_ACTION':
            return action.currentAction || initialState.currentAction;
        default:
            return state;
    }
}


export function alerts(state = initialState.alerts, action) {
    switch (action.type) {
        case 'ADD_ALERT':
            return [
                // ...state,
                action.alert
            ];
        case 'REMOVE_ALERT':
            return state.filter(alert => alert.id !== action.id);
        case 'SET_ALERTS':
            return action.alerts;
        default:
            return state;
    }
}

export function appStatus(state = initialState.appStatus, action) {
    switch (action.type) {
        case 'SET_APP_STATUS':
            return action.appStatus;
        default:
            return state;
    }
}